import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import FooterSection from "@/components/FooterSection";
import { useCurrency } from "@/contexts/CurrencyContext";

export default function OrderSuccess() {
  const [params] = useSearchParams();
  const orderId = params.get("order");
  const [order, setOrder] = useState(null);
  const { formatAmount } = useCurrency();

  useEffect(() => {
    if (!orderId) return;
    api.get(`/orders/${orderId}`).then((r) => setOrder(r.data)).catch(() => {});
  }, [orderId]);

  return (
    <div className="bg-midnight min-h-screen">
      <Navbar />
      <main className="pt-32 pb-20 px-6 md:px-12 lg:px-24" data-testid="order-success">
        <div className="max-w-2xl mx-auto text-center">
          <CheckCircle2 size={48} strokeWidth={1.1} className="text-silver mx-auto mb-6" />
          <div className="eyebrow mb-3 text-silver">Order Confirmed</div>
          <h1 className="font-serif text-white text-4xl md:text-5xl leading-[0.95]">
            Thank you. <span className="italic text-silver">Your piece</span> is in the atelier.
          </h1>
          {order && (
            <p className="mt-4 text-white/55 text-sm">
              Order <span className="text-silver tracking-widest">{order.order_id}</span> · {formatAmount(order.total)}
            </p>
          )}
          <p className="mt-6 text-white/65 font-light leading-relaxed">
            A confirmation has been sent. You can track your order from your account.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/orders"
              data-testid="success-view-orders"
              className="border border-white/25 px-7 py-3.5 text-[11px] tracking-[0.32em] uppercase text-white hover:border-white"
            >
              View my orders
            </Link>
            <Link
              to="/"
              className="bg-white text-black px-7 py-3.5 text-[11px] tracking-[0.32em] uppercase hover:bg-silver"
            >
              Continue browsing
            </Link>
          </div>
        </div>
      </main>
      <FooterSection />
    </div>
  );
}
